export const IconArrowUp = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <mask
        id="IconArrowUp_svg__a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#IconArrowUp_svg__a)">
        <path d="M12 22a.97.97 0 0 1-.713-.288A.97.97 0 0 1 11 21V5.825L7.1 9.7a.98.98 0 0 1-.688.288A.93.93 0 0 1 5.7 9.7a.95.95 0 0 1-.275-.7q0-.425.275-.7l5.6-5.6q.15-.15.325-.212.175-.063.375-.063t.375.063a.9.9 0 0 1 .325.212l5.6 5.6a.93.93 0 0 1 .275.688q0 .412-.275.712-.3.3-.713.3a.97.97 0 0 1-.712-.3L13 5.825V21q0 .424-.287.712A.97.97 0 0 1 12 22" />
      </g>
    </svg>
  );
};
